import {createFeatureSelector, createSelector} from '@ngrx/store';
import {DashboardState} from './dashboard.reducer';

const dashboardFeatureSelector = createFeatureSelector<DashboardState>('dashboard');

export const selectDashboard = createSelector(dashboardFeatureSelector, state => state.dashboard);

export const selectNumCandidates = createSelector(dashboardFeatureSelector, state => state.numCandidates);

